import { useMemo } from 'react'
import { useAppSelector } from '../redux/hooks'
import { selectUserData } from '../redux/actions/login/loginSlice'
import User from '../models/User'
import { AdminPermissionKey } from '../constants/adminPermissions'
import {
  getEffectivePermissions,
  hasPermission as checkPermission,
  isFullAdmin as checkFullAdmin,
} from '../utils/permissionUtil'

export function usePermissions() {
  const userState = useAppSelector<{ user: User }>(selectUserData)
  const user = userState.user

  return useMemo(
    () => ({
      user,
      isFullAdmin: checkFullAdmin(user),
      permissions: getEffectivePermissions(user),
      hasPermission: (permission: AdminPermissionKey) => checkPermission(user, permission),
    }),
    [user?._id, user?.role, user?.permissions?.join(',')],
  )
}
